module.exports = require("lowdb");


//////////////////
// WEBPACK FOOTER
// external "lowdb"
// module id = 32
// module chunks = 0